import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import * as _ from "lodash";
import { BaseComponent } from 'src/app/components/base/base.component';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { EFrequency } from 'src/app/domain/enum/frequency';
import { EZoneUsage } from 'src/app/domain/enum/zone-usage';
import { Strategy } from 'src/app/domain/strategy';
import { CoreData } from '../../core-data/core-data';
import { LoadingTask } from '../loading-task';
import { StringConverter } from '../string-converter';

@Component({
    selector: 'app-standard-box',
    templateUrl: './standard-measure-box.html',
    styleUrls: ['./standard-measure-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StandardMeasurenBoxDialog extends BaseComponent implements OnInit {

    EZoneUsage = EZoneUsage;
    private strategy: Strategy;

    // Filters
    UsageList: string[] = Object.values(EZoneUsage).filter(x => !isNaN(Number(x))).map(x => StringConverter.getZoneUsageName(x as EZoneUsage));
    SelectedUsage: EZoneUsage;
    AvailableMeasureList: ClientMeasure[] = [];
    ZoneProcessList: ClientMeasure[] = [];
    SelectedParent: ClientMeasure;

    MeasureList: ClientMeasure[] = [];
    SelectedMeasureList: ClientMeasure[] = [];

    // Model: ClientMeasure = new ClientMeasure();
    WithBattery: boolean;
    WithExpressDelay: boolean;
    EDIAnalysisNumber: string;
    HasFan: boolean;
    IsAccredited: boolean = true;

    AlreadyPicked: ClientMeasure[] = [];
    OrderableList: ClientMeasure[] = [];

    get IsFDX() {
        return this.strategy.IsFDX;
    }

    constructor(
        protected coreData: CoreData,
        public LoadingTask: LoadingTask,
        public dialogRef: MatDialogRef<StandardMeasurenBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {
        super(coreData)
        this.strategy = data.strategy;
        this.AlreadyPicked = data.alreadyPicked;
        this.OrderableList = data.orderableList;
    }

    ngOnInit() {
        this.AvailableMeasureList = _.differenceBy(this.OrderableList, this.AlreadyPicked, y => y.SamplingId);
        this.ZoneProcessList = _.uniqBy(this.OrderableList, y => y.ParentName);
    }

    SetSelection(event: MatSelectionListChange) {

        if (event.options[0].selected)
            this.SelectedMeasureList.push(...event.options.filter(e => e.selected).map(x => x.value));
        else
            _.remove(this.SelectedMeasureList, x => x.SamplingId === event.options[0].value.SamplingId)
    }

    getFrequencyLabel(freq: EFrequency) {
        return this.IsFDX ? StringConverter.getFDXFrequencyName(freq) : StringConverter.getFrequencyName(freq)
    }

    getZoneOrProcessAvailable() {
        this.ZoneProcessList = _.uniqBy(this.AvailableMeasureList.filter(x => x.ZoneUsage === this.SelectedUsage), y => y.ParentName);
        this.MeasureList = []
        this.SelectedParent = null;
    }

    getMeasureAvailableForThatZoneProcess() {
        this.MeasureList = this.AvailableMeasureList.filter(x => x.ParentName === this.SelectedParent.ParentName && x.ZoneUsage === this.SelectedUsage);

        this.MeasureList.forEach(x => x.IsSelected = true);
        this.SelectedMeasureList = [];
        this.SelectedMeasureList.push(...this.MeasureList);
    }

    CanAdd() {
        return this.SelectedMeasureList.length > 0;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {

        if (!this.CanAdd())
            return;

        let list = this.SelectedMeasureList.filter(x => x.IsSelected)
        list.forEach(x => {
            x.PumpWithBattery = this.WithBattery;
            x.Rush = this.WithExpressDelay;
            x.HasFan = this.HasFan;
            x.EDIAnalysisNumber = this.EDIAnalysisNumber;
            x.IsAccredited = this.IsAccredited;
        })

        this.dialogRef.close(list);
    }

    public compareWith(m1: ClientMeasure, m2: ClientMeasure) {
        return m1 && m2 ? m1.ParentName === m2.ParentName : m1 === m2;
    }
}
